export class Module {
  ModuleId: number;
  Name: string;
  IsActive: boolean;
  DefaultTransactionFee: number;
  DefaultTransactionFeeCurrency: string;
  DefaultRefundCost: number;
  DefaultRefundCostCurrency: string;

  constructor(moduleId: number, name: string, defaultTransactionFee: number, defaultTransactionFeeCurrency: string, defaultRefundCost: number, defaultRefundCostCurrency: string) {
    this.ModuleId = moduleId;
    this.Name = name;
    this.IsActive = true;
    this.DefaultTransactionFee = defaultTransactionFee;
    this.DefaultTransactionFeeCurrency = defaultTransactionFeeCurrency;
    this.DefaultRefundCost = defaultRefundCost;
    this.DefaultRefundCostCurrency = defaultRefundCostCurrency;
  }
}

export let ModuleIgnoreList: any[] = [];
